/* eslint-disable no-unused-vars */
import React, { forwardRef } from 'react';
import './ExploreIndia.css';
import { Box, Grid, Typography } from '@mui/material';
import indiaMap from '../../../assets/images/explore_india_map.webp';
import CustomButton from '../../Common/button';
import { useNavigate } from 'react-router-dom';

const ExploreIndia = forwardRef(({ _ }, ref) => {
  const navigate = useNavigate();

  return (
    <Box className="experience-container" ref={ref}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6} className="text-content">
          <Typography gutterBottom className="title">
            Experience India: Discover Wonders with Every Click.
          </Typography>
          <Typography gutterBottom className="description" mb={3}>
            Discover the magic of India - Explore vibrant cultures, breathtaking landscape, and
            unique experience tailored just for you.
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <CustomButton
              width="290px"
              title="Explore All Packages"
              onClick={() => navigate('/explore')}
            />
            <CustomButton
              title="eBrochure"
              onClick={() =>
                window.open(
                  'https://issuu.com/kesari-tours/docs/wtm_brochure_2024_online',
                  '_blank'
                )
              }
              backgroundColor="#27306B"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} className="map-container">
          <Box
            component="img"
            src={indiaMap}
            alt="India Map"
            className="india-map"
            sx={{
              width: '100%',
              height: 'auto',
              maxWidth: 1200,
              maxHeight: 800
            }}
            width="1200"
            height="800"
          />
        </Grid>
      </Grid>
    </Box>
  );
});

ExploreIndia.displayName = 'ExploreIndia';

export default ExploreIndia;
